var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('AmenityItem',{key:item.raCode,attrs:{"lang":_vm.lang,"locale":_vm.locale,"localeAmenity":_vm.localeAmenity,"item":item,"roomKey":_vm.roomKey}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }